import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsApprovalStatusReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsApprovalStatusReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/approval_status_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
